import { BigCheckbox, FieldShell } from './FieldPrimitives';
import { MENTAL_HEALTH_CONDITIONS } from '@/constants/intakeForm';

const NONE_OPTION = 'None of the above';

const MentalHealthSection = ({ responses, setField }) => {
  const list = responses.mental_health || [];

  const handleToggle = (item) => {
    let next;
    if (item === NONE_OPTION) {
      // 'None' is exclusive — toggling it clears everything else.
      next = list.includes(NONE_OPTION) ? [] : [NONE_OPTION];
    } else {
      const filtered = list.filter((x) => x !== NONE_OPTION);
      next = filtered.includes(item)
        ? filtered.filter((x) => x !== item)
        : [...filtered, item];
    }
    setField('mental_health', next);
  };

  return (
    <div className="space-y-6">
      <p className="text-base md:text-lg text-gray-700">
        Check anything you have experienced or been diagnosed with. This stays
        private and only your doctor sees it.
      </p>

      <FieldShell label="Mental health history">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {MENTAL_HEALTH_CONDITIONS.map((cond) => (
            <BigCheckbox
              key={cond}
              id={`mh_${cond.replace(/\W+/g, '_')}`}
              checked={list.includes(cond)}
              onChange={() => handleToggle(cond)}
            >
              {cond}
            </BigCheckbox>
          ))}
        </div>
      </FieldShell>
    </div>
  );
};

export default MentalHealthSection;
